// extracted by mini-css-extract-plugin
export default {"doctor":"Doctor_doctor__Z4eO5","name":"Doctor_name__uTrL+","overview":"Doctor_overview__-m7Nb","achievements":"Doctor_achievements__eoPt0","container":"Doctor_container__54wO6"};